module.exports = __webpack_public_path__ + "static/img/8.13e801d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/8.png
// module id = Sd7t
// module chunks = 0